import React, { useState } from 'react';
import createContainer from '../../../api/cars/createContainer';
import { useNavigate } from 'react-router-dom';

// components
import Form from '../../../components/Form/Form';
import Header from '../../../components/Header/Header';

// icons
import icon from '../../../brand/generated/sidebar/cars.svg';

const formStyles = {
  container: { display: 'grid', gap: '20px', gridTemplateColumns: '1fr 1fr 1fr 1fr' },
};

const CarContainersCreate = () => {
  const navigate = useNavigate();
  const [container, setContainer] = useState([
    { type: 'selectMarks', value: undefined },
    { type: 'selectModelsOld', value: undefined, params: () => container[0].value },
    { type: 'input', value: undefined, label: 'Ð¦ÐµÐ½Ð° Ð¾Ñ', placeholder: 'Ð£ÐºÐ°Ð¶Ð¸ÑÐµ Ð¼Ð¸Ð½Ð¸Ð¼Ð°Ð»ÑÐ½ÑÑ ÑÐµÐ½Ñ', format: 'number' },
    { type: 'document', value: undefined, text: 'Ð¤Ð¾ÑÐ¾', label: 'ÐÐ°Ð³ÑÑÐ·Ð¸ÑÐµ ÑÐ¾ÑÐ¾', id: 'photo' },
    { type: 'document', value: undefined, text: 'ÐÑÐ°Ð¹ÑÐ»Ð¸ÑÑ', label: 'ÐÐ°Ð³ÑÑÐ·Ð¸ÑÐµ Ð´Ð¾ÐºÑÐ¼ÐµÐ½Ñ', id: 'document' },
  ]);

  const createMarkModel = () => {
    const json = JSON.stringify({ markId: container[0].value, modelId: container[1].value, customPrice: Number(container[2].value) });
    const data = new FormData();
    data.append('json', json);
    data.append('photo', container[3].value);
    data.append('priceList', container[4].value);

    createContainer(data).then(() => navigate('/cars/containers'));
  };
 
  return (
    <>
      <Header title={'ÐÐ¾Ð²Ð°Ñ Ð¼Ð°ÑÐºÐ° Ð¸ Ð¼Ð¾Ð´ÐµÐ»Ñ'} icon={icon} />
      <div style={{ paddingBottom: '20px' }}>
        <Form
          inputs={container}
          title={'ÐÐ°ÑÐºÐ° Ð¸ Ð¼Ð¾Ð´ÐµÐ»Ñ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ'}
          grid={formStyles.container}
          action={'Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ'}
          handlerSetState={setContainer}
          handleSubmit={createMarkModel}
          border
        />
      </div>
    </>
  );
};

export default CarContainersCreate;
